import {
  Box,
  Grid,
  GridItem,
  HStack,
  Icon,
  Input,
  Text,
  VStack
} from "@chakra-ui/react";
import React from "react";
import { FiTag } from "react-icons/fi";
import { RiAdvertisementLine, RiPaletteLine } from "react-icons/ri";

interface CampaignDetailsProps {
  linkName: string;
  adSetName: string;
  adName: string;
  onChange: (field: string, value: string) => void;
  disabled?: boolean;
}

export const CampaignDetails: React.FC<CampaignDetailsProps> = ({
  linkName,
  adSetName,
  adName,
  onChange,
  disabled = false
}) => {
  return (
    <Box bg="white" shadow="sm" rounded="lg" p={6}>
      <HStack mb={4}>
        <Icon as={RiAdvertisementLine} color="blue.500" boxSize={5} />
        <Text fontWeight="semibold" fontSize="lg">
          Campaign Details
        </Text>
      </HStack>
      <VStack gap={4} align="stretch">
        <Grid templateColumns="repeat(1, 1fr)" gap={4}>
          <GridItem>
            <HStack mb={2}>
              <Icon as={FiTag} color="gray.400" boxSize={4} />
              <Text fontSize="sm" fontWeight="medium">
                Campaign Name (Optional)
              </Text>
            </HStack>
            <Input
              name="linkName"
              value={linkName}
              onChange={(e) => onChange("linkName", e.target.value)}
              placeholder="e.g., Summer Sale 2024"
              size="lg"
              disabled={disabled}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)"
              }}
            />
            <Text fontSize="sm" color="gray.500" mt={1}>
              Name of your marketing campaign
            </Text>
          </GridItem>
          <GridItem>
            <HStack mb={2}>
              <Icon as={RiAdvertisementLine} color="gray.400" boxSize={4} />
              <Text fontSize="sm" fontWeight="medium">
                Ad Set Name (Optional)
              </Text>
            </HStack>
            <Input
              name="adSetName"
              value={adSetName}
              onChange={(e) => onChange("adSetName", e.target.value)}
              placeholder="e.g., Toronto Buyers"
              size="lg"
              disabled={disabled}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)"
              }}
            />
            <Text fontSize="sm" color="gray.500" mt={1}>
              Target audience or ad group
            </Text>
          </GridItem>
          <GridItem>
            <HStack mb={2}>
              <Icon as={RiPaletteLine} color="gray.400" boxSize={4} />
              <Text fontSize="sm" fontWeight="medium">
                Ad Name (Optional)
              </Text>
            </HStack>
            <Input
              name="adName"
              value={adName}
              onChange={(e) => onChange("adName", e.target.value)}
              placeholder="e.g., Banner - Blue CTA"
              size="lg"
              disabled={disabled}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)"
              }}
            />
            <Text fontSize="sm" color="gray.500" mt={1}>
              Specific ad variant or creative
            </Text>
          </GridItem>
        </Grid>
      </VStack>
    </Box>
  );
};
